import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const topicsDetailsApi = createAsyncThunk(
    'auth/topics/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.topicsAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const topicsDetailsSlice = createSlice({
    name: 'topics details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resettopics: () => intialState,
      },
    extraReducers: (builder) => {
        builder.addCase(topicsDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(topicsDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(topicsDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const {  resettopics } = topicsDetailsSlice.actions;
export const topicsDetailsReducer = topicsDetailsSlice.reducer